'use client'

import React from 'react'
import { useIsAdminQuery } from '@/shared/api-rtk/index.js'
import { API_URL } from '@/shared/constants/linksApi.js'

export const EditButton = ({ item, item_id }) => {
    const { data: adminData } = useIsAdminQuery()

    return (
        adminData &&
        adminData.is_admin && (
            <div className="admin__editBtn">
                <a
                    href={
                        API_URL +
                        `/cms/admin/index.php?route=catalog/${item}/edit&${item}_id=` +
                        item_id +
                        '&token=' +
                        adminData.token
                    }
                    target="_blank"
                >
                    Редактировать
                </a>
            </div>
        )
    )
}
